export default __webpack_public_path__ + "static/media/mObywatel_icon.47ddfe90.png";